import {useCallback, useEffect, useState} from 'react';
import {profilesService} from '@services/profiles.service';

/**
 * Carga la foto de perfil: primero GET /usuarios/me/photo (blob), luego URLs /uploads.
 */
export const useProfilePhoto = initialPath => {
    const [path, setPath] = useState(initialPath || null);
    const [blobSrc, setBlobSrc] = useState(null);
    const [failed, setFailed] = useState(false);

    const syncFromServer = useCallback(async nextPath => {
        setPath(nextPath || null);
        setFailed(false);
        setBlobSrc(null);

        if (!nextPath) {
            profilesService.revokePhotoBlobCache();
            return;
        }

        const blob = await profilesService.getPhotoDisplayBlob(nextPath);

        if (blob) {
            setBlobSrc(blob);
        }
    }, []);

    useEffect(() => {
        syncFromServer(initialPath);
    }, [initialPath, syncFromServer]);

    useEffect(() => {
        const onPhotoUpdated = e => {
            syncFromServer(e.detail?.foto_perfil_url ?? null);
        };

        window.addEventListener('profile-photo-updated', onPhotoUpdated);
        return () => window.removeEventListener('profile-photo-updated', onPhotoUpdated);
    }, [syncFromServer]);

    return {
        path,
        blobSrc,
        failed,
        setFailed,
        hasPhoto: Boolean(path),
        refresh: syncFromServer
    };
};
